import React, {Component} from 'react';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn  } from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import Assignment from 'material-ui/svg-icons/action/assignment';
import Divider from 'material-ui/Divider';
import {Col} from 'react-bootstrap';
import { convertSecondsToClockFormat } from '../../utilities/time';

export default class LedgerGroup extends Component {
    render() {
      const title = this.props.title;
      const dates = this.props.dates;
      const agentHours = this.props.agentHours;
      const realtor = this.props.realtor;
      const sortedEntries = sortedTimersDate(dates);
      const allHours = aggregateHours(sortedEntries, agentHours, realtor);
      const { seconds, minutes } = allHours

      const datesEntries = Object.values(sortedEntries).map(dates => {
        return (
          <Card key={dates.title} style={{ marginBottom: 15, borderRadius: 10 }} initiallyExpanded={true}>
            <CardHeader
              title={dates.title}
              titleStyle={{ fontSize: 20 , fontWeight: '' }}
              actAsExpander={true}
              showExpandableButton={true}
              />
            <Divider />
            <CardText expandable={true}>
              <Table>
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                  >
                  <TableRow>
                    <TableHeaderColumn style={{ fontSize: 14 }}> Agent</TableHeaderColumn>
                    <TableHeaderColumn style={{ fontSize: 14 }}> Project </TableHeaderColumn>
                    <TableHeaderColumn style={{ fontSize: 14 }}> Task </TableHeaderColumn>
                    <TableHeaderColumn style={{ fontSize: 14 }}> VA</TableHeaderColumn>
                    <TableHeaderColumn style={{ fontSize: 14 }}> Time </TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  stripedRows={true}>
                  {
                    Object.values(dates.timers).map(entry=>{
                      const { seconds, minutes } = convertSecondsToClockFormat(entry.totalTime);
                      return (
                        <TableRow>
                          <TableRowColumn style={{ fontSize: 13 }}>{entry.agent}</TableRowColumn>
                          <TableRowColumn style={{ fontSize: 13 }}>{entry.project}</TableRowColumn>
                          <TableRowColumn style={{ fontSize: 13 }}>{entry.task}</TableRowColumn>
                          <TableRowColumn style={{ fontSize: 13 }}>{entry.va}</TableRowColumn>
                          <TableRowColumn style={{ fontSize: 16, fontWeight: 800 }} >{minutes + ':' + seconds}</TableRowColumn>
                        </TableRow>
                      );
                    })
                  };
                </TableBody>
              </Table>
            </CardText>
          </Card>
        )
      }).reverse();

      return (
        <Col xs={12} sm={12} md={12}>
          <Card style={{ marginTop: 15, marginLeft: -25, marginRight: -25, borderRadius: 10, backgroundColor: '#FAFAFA' }} key={title} initiallyExpanded={true}>
             <CardHeader
               title={title}
               subtitle={realtor ? `${minutes}:${seconds} Minutes Remaining` : `${minutes} : ${seconds}`}
               titleStyle={{ color: 'black', fontSize: 19 }}
               subtitleStyle={{ fontSize: 12}}
               actAsExpander={true}
               showExpandableButton={true}
             />
           <CardText expandable={true} style={{ backgroundColor: '#455A64' }}>
             {datesEntries}
           </CardText>
           <CardActions>
             <FlatButton label="Export" icon={<Assignment />} onClick={this.props.export} />
           </CardActions>
         </Card>
       </Col>
      );
    }
  }

function sortedTimersDate(timers) {
      let innerGroups = {}
      for (let entry of timers ) {
        const startTime = new Date(entry.startTime);
        const date = startTime.toLocaleDateString();
        if (!innerGroups[date]) {
          innerGroups[date] = {
            title: date,
            timers: []
          }
        }
        innerGroups[date].timers.push(entry);
      }
      return innerGroups
  }

function aggregateHours(sortedTimers, agentHours, realtor) {
    let num = 0
    for (let entry of Object.values(sortedTimers)) {
      for(let entry2 of Object.values(entry.timers)) {
        num += entry2.totalTime;
      }
    }
    if (realtor) {
      return convertSecondsToClockFormat(agentHours);
    }
    return convertSecondsToClockFormat(num);
}



// WEBPACK FOOTER //
// ./src/components/timetracker/ledger_group.jsx